import React from 'react';
import '../../logeo.css';
import logo2 from '../../imagen/avatar.png';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Link } from 'react-router-dom';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import { RecuperarContrasena } from './RecuperarContrasena';
import { NuevoUsuario } from './NuevoUsuario';
import { Manual } from './Manual';
import { FooterContactoQuadrum } from '../../FooterContactoQuadrum';
import { ImagenLogoCapufe } from '../../ImagenLogoCapufe';
import { Avisos } from './Avisos';
import { autenticar } from '../servicios/ServicioAutenticacion';
import { deleteToken, deleteUsuario } from "../servicios/ServicioManejadorToken";
export class Logeo extends React.Component {
    constructor() {
        super();        
        this.state = {
            usuario: {},
            errores: {},
            aviso: null,
            mostrarModalAviso: false,
            avisosExternos: []
        }
    deleteToken();
    deleteUsuario();
    }

    asignarValores(event) {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    validarFormulario = (objetoUsuario) => {
        const errores = {};
        if (!objetoUsuario.usuario)
            errores.usuario = "El campo es requerido";
        if (!objetoUsuario.contrasena)
            errores.contrasena = "El campo es requerido";
        return errores;
    }

    iniciarSesion() {
        let { usuario } = this.state;

        const resultadoValidacion = this.validarFormulario(usuario);

        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {
            autenticar(usuario.usuario,usuario.contrasena).then(response =>{
                this.props.history.push("/Capufe/bienvenido/ticket");
              }).catch(error => {
                this.growl.show({severity: "error",summary: "",detail:error});
              });
        }
    }

    cerrarModal = () => {
        this.setState({ mostrarModalAviso: false });
    }

    obtenerAviso() {
        servicioUsuario.obtenerAvisoPrivacidad().then((response) => {
            if (response.data.error === false)
                this.setState({ aviso: response.data.mensaje, mostrarModalAviso: true })
        }).catch((error) => { });
    }

    componentWillUnmount() { }

    render() {
        let { errores, usuario, aviso } = this.state;

        const footer = (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={this.cerrarModal} />
            </div>
        );

        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <ImagenLogoCapufe />

                <div className="p-fluid" >
                    <div className="p-grid">
                        <div className="p-col-12">
                            <Avisos />
                        </div>

                        <div className="p-col-12">
                            <div className="card card-w-title">

                                <div className="p-grid">

                                    <div className="p-col-12 p-md-6">
                                        <center>
                                            <div className="p-col-12 p-md-6">
                                                <center> <img style={{ maxWidth: '30%', maxHeight: '60px' }} src={logo2} alt="logo" /></center>
                                            </div>
                                            <div className="p-col-12 p-md-6">
                                                <div className="p-inputgroup">
                                                    <span className="p-inputgroup-addon"><i className="material-icons">account_circle</i></span>
                                                    <InputText placeholder="Usuario" id="usuario" name="usuario.usuario" className={errores.usuario ? 'p-error' : ''} value={usuario.usuario || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                                </div>
                                                {errores.usuario ? <div><br /> <Message severity="error" text={errores.usuario} /> </div> : null}
                                            </div>
                                            <div className="p-col-12 p-md-6">
                                                <div className="p-inputgroup">
                                                    <span className="p-inputgroup-addon"><i className="material-icons">lock_open</i></span>
                                                    <Password placeholder="Contraseña" feedback={false} id="contrasena" name="usuario.contrasena" className={errores.contrasena ? 'p-error' : ''} value={usuario.contrasena || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                                </div>
                                                {errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}
                                            </div>
                                            <div className="p-col-12 p-md-6">
                                                <Button label="Acceder" icon="pi-md-person" onClick={this.iniciarSesion.bind(this)} />
                                            </div>

                                            <div className="p-col-12 p-md-6">
                                                ¿Eres usuario nuevo? <NuevoUsuario />
                                                <RecuperarContrasena />
                                                <Manual />
                                            </div>
                                        </center>
                                    </div>

                                    <div className="p-col-12 p-md-6">

                                        <strong >BENEFICIOS DE USUARIOS REGISTRADOS</strong>
                                        <ul className="circulo">
                                            <li> Descarga del PDF y XML en cualquier lugar</li>
                                            <li>Almacenamiento de Facturas</li>
                                            <li>Envío por correo</li>
                                            <li>Historial de Factura</li>

                                        </ul>
                                        <span>Números de atención a cliente (01) 442 161 2565, (01) 551 209 1825  </span>
                                        <p><span style={{ color: "red" }}>"Una vez emitida la factura no se podrá remitir a un RFC diferente ni corregir datos."</span></p>

                                        <div className="p-grid">
                                            <div className="p-col-12 p-md-6">
                                                <Link to="/Capufe/facturacionrapida" style={{ border: "none", backgroundColor: "transparent", outline: "none", }} ><h1> <strong style={{ color: '#4CAF50' }}>Facturación sin registro</strong></h1></Link>
                                            </div>
                                            <div className="p-col-12 p-md-6">
                                                <button onClick={this.obtenerAviso.bind(this)} style={{ border: "none", backgroundColor: "transparent", outline: "none", }} ><h1> <strong style={{ color: '#4CAF50' }}>Aviso de Privacidad</strong></h1></button>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <FooterContactoQuadrum />
                <div>
                    <Dialog closeOnEscape={false} header="Aviso de Privacidad" visible={this.state.mostrarModalAviso} modal={true} onHide={this.cerrarModal} footer={footer} >
                        <br></br>
                        <ScrollPanel style={{ width: '100%', height: '400px' }}>
                            <p style={{ textAlign: 'justify' }}>{aviso}</p>
                        </ScrollPanel>
                    </Dialog>
                </div>


            </div >

        );

    }
}
